import { Navigate, useSearchParams } from 'react-router-dom';
import { buildContractSearchParams } from '../newJourney/buildContractSearchParams';

export default function ContractAddressRedirect() {
  const [searchParams] = useSearchParams();
  return <Navigate replace to={`/contract/user${buildContractSearchParams(searchParams)}`} />;
}
